import React, { useEffect, useState } from 'react';
import { Button, Modal, Table } from 'react-bootstrap';

import { useAuth } from '../../../Auth';
import { useAxios } from '../../../AxiosHandler';
import { useTranslate } from 'react-polyglot';
import { toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import './EmailSender.scss';
import Field from '../../Shared/Wizard/Field/Field';

function EmailSender(props) {
    const auth = useAuth();
    const t = useTranslate();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;


    const notifySuccess = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "success-toast"
    });

    const [updateTable, setUpdateTable] = useState(0);

    const [message, setMessage] = useState("");
    const [subject, setSubject] = useState("");
    const [messages, setMessages] = useState([]);

    const handleSendEmail = () => {
        axios.post('/api/emailsender/', {
            messages,
            attachMapImage: props.attachMapImage,
        }
        ,{
            headers: {'x-access-token': auth.user["token"]}
        })
        .then(function (response) {
            setUpdateTable(updateTable + 1);
            notifySuccess(t("emailsender.toast.sent"));
            setMessages(response.data);
        });
    };

    const handleOnCancel = () =>{
        if(props.onCancel != undefined) {
            props.onCancel();
        }
        setMessage("");
        setSubject("");
        setMessages([]);
    }

    const handleOnHide = () =>{
        if(props.onHide != undefined) {
            props.onCancel();
        }
        setMessage("");
        setSubject("");
        setMessages([]);
    }

    useEffect(() => {
        if (props.recipients != undefined) {
            setMessages(props.recipients.map(r => {
                return {
                    email: r.email,
                    name: r.name,
                    subject: !props.customMessages ? subject : r.subject,
                    text: !props.customMessages ? message : r.message,
                    status: ""
                };
            }));
        }
    }, [props.recipients]);

    useEffect(() => {
        if (props.recipients != undefined && !props.customMessages) {
            setMessages(props.recipients.map(r => {
                return {
                    email: r.email,
                    name: r.name,
                    subject: subject,
                    text: message,
                    status: ""
                };
            }));
        }
    }, [message]);

    useEffect(() => {
        if (props.recipients != undefined && props.customMessages) {
            setMessages(props.recipients.map(r => {
                return {
                    email: r.email,
                    name: r.name,
                    subject: r.subject,
                    text: r.message,
                    status: ""
                };
            }));
        }
    }, [props.customMessages]);

    return (
        <Modal show={props.show} onHide={handleOnHide} size="xl">
            <Modal.Header closeButton>
                <Modal.Title>
                    {t("emailsender.title_new")}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {!props.customMessages ?
                    <React.Fragment>
                        <Field
                            type="input"
                            title={t("emailsender.subject")}
                            value={subject}
                            onChange={value => setSubject(value)}
                        ></Field>
                        <Field
                            type="textarea"
                            title={t("emailsender.message")}
                            value={message}
                            onChange={value => setMessage(value)}
                        ></Field>
                    </React.Fragment>
                : null}
                {props.attachMapImage ?
                    <p>{t("emailsender.map_image_attached_info")}</p>
                : null}
                <Table striped>
                    <thead>
                        <tr>
                            <th>{t("emailsender.recipient")}</th>
                            { props.customMessages ? <th>{t("emailsender.message")}</th> : null}
                            <th>{t("emailsender.status")}</th>
                        </tr>
                    </thead>
                    <tbody>
                    { messages != undefined ? messages.map((message, key) =>
                        <tr key={key}>
                            <td>{message["email"]} {message["name"]}</td>
                            { props.customMessages ? 
                                <td>
                                    <div className="messagecontainer">
                                        {(message["text"] as String).split("\n").map((t, key) =>
                                            <p key={key} style={{ margin: "0px" }}>{t == "" ? <span>&nbsp;</span> : t}</p>
                                        )}
                                    </div>
                                </td>
                            : null}
                            <td>{message["status"]}</td>
                        </tr>
                    ) : null }
                    </tbody>
                </Table>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handleOnCancel}>
                    {t("emailsender.cancel")}
                </Button>
                <Button onClick={handleSendEmail}>
                    {t("emailsender.send")}
                </Button>
            </Modal.Footer>
    </Modal>
    );
}

export default EmailSender;